import type { z } from 'zod'
import type { betweenBigIntSchema } from './schema'

export const checkValueIsBetweenBigInt = ({
  value,
  schema,
}: {
  readonly value: bigint
  readonly schema: z.infer<typeof betweenBigIntSchema>
}): boolean => {
  if (schema.min !== undefined && value < schema.min) {
    return false
  }
  if (schema.max !== undefined && value > schema.max) {
    return false
  }
  return true
}
